import { render } from "./GenererRedevanceTemponPage.vue?vue&type=template&id=57bd8bb0&ts=true"
import script from "./GenererRedevanceTemponPage.vue?vue&type=script&lang=ts"
export * from "./GenererRedevanceTemponPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__